import './App.css';
import {useCallback, useEffect, useState} from "react";

function App() {
  const TABLE_MASTER = "ABCDEFGHIJKLMNOPQRSTUVXYZ";

  const [anagram, setAnagram] = useState(['', '', '', '', '', '', '', '',]);
  const [cryptCode, setCryptCode] = useState(['', '', '', '', '', '', '', '',]);

  const [keyword, setKeyword] = useState('DISCREPANTLY');
  const [cryptTable, setCryptTable] = useState(TABLE_MASTER);
  const [words, setWords] = useState([]);
  const [fragment, setFragment] = useState(
    [['', ''], ['', ''], ['', ''], ['', ''],
      ['', ''], ['', ''], ['', ''], ['', '']]);

  const handleDrop = useCallback((e) => {
    const [fromIndex, destIndex] = moveIndexes(e);

    setAnagram(anagram => {
      return moveArray(anagram, fromIndex, destIndex);
    })

    setCryptCode(cryptCode => {
        return moveArray(cryptCode, fromIndex, destIndex);
      }
    )

  }, []);

  useEffect(() => {
    updateKeyword('DISCREPANTLY');
    document.querySelectorAll(".box.drag").forEach(element => {
      element.draggable = true;
      element.addEventListener("dragstart", onDragStart);
    })

    document.querySelectorAll(".box.drop").forEach((element) => {
      element.addEventListener("dragover", onDragOver);
      element.addEventListener("dragenter", onDragEnter);
      element.addEventListener("dragleave", onDragLeave);
    });

  }, []);

  document.querySelectorAll(".box.drop").forEach((element) => {
    element.removeEventListener("drop", handleDrop);
    element.addEventListener("drop", handleDrop);
  });

  function onDragStart(event) {
    event.dataTransfer.setData("text", event.currentTarget.dataset.index);
  }

  function moveIndexes(event) {
    event.currentTarget.classList.remove("dragging");

    let fromIndex = event.dataTransfer.getData("text");
    fromIndex = isNaN(fromIndex) ? -1 : parseInt(fromIndex);

    let destIndex = event.currentTarget.dataset.index;
    destIndex = isNaN(destIndex) ? -1 : parseInt(destIndex);

    return [fromIndex, destIndex];
  }

  function moveArray(anagram, fromIndex, destIndex) {
    if (fromIndex === destIndex) {
      return anagram;
    }

    if ((fromIndex < 0) || (destIndex < 0) || (fromIndex >= 8) || (destIndex >= 8)) {
      return anagram;
    }

    let newAnagram = [...anagram];
    const removedAnagram = newAnagram.splice(fromIndex, 1);
    newAnagram.splice(destIndex, 0, removedAnagram[0]);

    return newAnagram;
  }

  function onDragEnter(event) {
    event.currentTarget.classList.toggle("dragging");
  }

  function onDragLeave(event) {
    event.currentTarget.classList.toggle("dragging");
  }

  function onDragOver(event) {
    event.preventDefault();
  }


  const getDiffStrings = (keyword, base) => {
    const baseList = [...base];
    const keywordList = [...keyword];

    return baseList.filter(function (baseString) {
      return !keywordList.includes(baseString);
    });
  }

  const handleKeywordChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    updateKeyword(toHalfWidth(event.target.value).toUpperCase())
  };

  const updateKeyword = (keywordString) => {
    if (keywordString) {
      const diffString = getDiffStrings(keywordString, TABLE_MASTER).join('')
      setCryptTable(keywordString + diffString);
    }
    setKeyword(keywordString);
  }

  const handleLetterChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const letter = toHalfWidth(event.target.value).toUpperCase();
    const index = event.target.dataset.index;

    let fragmentList = [...fragment];
    fragmentList[index][0] = letter;
    setFragment(fragmentList);

    // アルファベット暗号表テーブルから抽出
    updateAnagram(fragmentList);
  }

  const updateAnagram = (fragmentList) => {
    // アルファベット暗号表テーブルから抽出
    const newAnagram = fragmentList.map((data, index) => {
      const letterIndex = [...cryptTable].indexOf(data[0])

      if (letterIndex === -1) {
        return '';
      }

      return [...TABLE_MASTER][letterIndex];
    });

    const newNumbers = fragmentList.map((data) => {
      const letterIndex = [...cryptTable].indexOf(data[0])

      if (letterIndex === -1) {
        return '';
      }

      return data[1];
    });

    // console.log('newAnagram', newAnagram)
    // console.log('newNumbers', newNumbers)

    setAnagram(newAnagram);
    setCryptCode(newNumbers);
  }

  const handleNumberChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const number = toHalfWidth(event.target.value).toUpperCase();
    const index = event.target.dataset.index;

    let fragmentList = [...fragment];
    fragmentList[index][1] = number;
    setFragment(fragmentList);

    const newNumbers = fragmentList.map((data) => {
      const letterIndex = [...cryptTable].indexOf(data[0])

      if (letterIndex === -1) {
        return '';
      }

      return data[1];
    });

    setCryptCode(newNumbers);
  }

  const handleSave = () => {
    setWords([...words, [anagram, cryptCode]]);
  }

  const toHalfWidth = (strVal) => {
    return strVal.replace(/[！-～]/g,
      function (tmpStr) {
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
      }
    );
  }

  const cryptTableList = [...cryptTable];
  const plainCodes = [...TABLE_MASTER].map((data, index) =>
    <div key={index} className="border border-blue-300">
      <div className=" bg-blue-800 text-xl px-3 py-2 text-white">
        {data}
      </div>
      <div className="bg-white text-xl px-3 py-2">
        {cryptTableList[index]}
      </div>
    </div>
  );

  const rows = fragment.map((data, index) =>
    <div key={index} className="border border-blue-300">
      <div className="w-6 h-6 bg-white">
        {data[0]}
      </div>
      <div className="w-6 h-6 bg-white">
        {data[1]}
      </div>
    </div>
  );

  const anagramPanels = anagram.map((data, index) =>
    <div key={index} className="border border-gray-700 font-bold box drag drop" data-index={index}>
      <div className="bg-white text-5xl w-16 h-20 flex items-center justify-center">
        {data}
      </div>
    </div>
  );

  const cryptCodePanels = cryptCode.map((data, index) =>
    <div key={index} className="border border-gray-700 font-bold">
      <div className="bg-white text-3xl w-16 h-14 flex items-center justify-center">
        {data}
      </div>
    </div>
  );

  const wordPanels = words.map((data, index) =>
    <div key={index} className="">
      <div className="bg-white text-lg flex items-center justify-center me-3">
        {data[0]}
        ({data[1]})
      </div>
    </div>
  );

  const fragmentForms = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'].map((key, index) =>
    <div key={index} className="border border-gray-600 rounded bg-neutral-400 px-4 py-2 me-2">
      <input maxLength="1" className="w-8 px-2" onChange={handleLetterChange}
             value={fragment[index][0]} placeholder={key} data-index={index}/>
      <span className="w-9 mx-1">-</span>
      <input maxLength="1" className="w-8 px-2" onChange={handleNumberChange}
             value={fragment[index][1]} placeholder={(index + 1)} data-index={index}/>
    </div>
  );

  return (
    <div className="App">
      <h1 className="mt-5 mb-6 text-4xl">Fallout76 核発射コード補助ツール</h1>
      <div className="p-2 m-2 flex justify-around items-center">
        <div className="bg-amber-100 px-4 py-4 rounded-s">
          <label className="pe-2">サイロのキーワード
            <input name="flagment4" className=" px-2 mx-2 rounded" onChange={handleKeywordChange}
                   value={keyword}/>
          </label>
        </div>
      </div>

      <div className="p-2 m-2 flex justify-around items-center flex-col">
        <div className="mb-2">
          <label className="pe-2">コード断片</label>
        </div>
        <div className="bg-amber-100 px-4 py-4 rounded-s flex items-center">
          {fragmentForms}
        </div>
      </div>

      <div className="p-2 m-2 flex justify-around items-center">
        <div className="bg-indigo-100 px-4 py-2 rounded-s">
          <div>暗号表</div>
          <div className="flex justify-center items-center mt-4">
            {plainCodes}
          </div>
        </div>
      </div>

      {/*<div className="px-4 py-2 flex justify-center items-center">*/}
      {/*  {rows}*/}
      {/*</div>*/}

      <div className="flex justify-center items-center mt-4">暗号</div>
      <div className="flex justify-center items-center mt-2">
        {anagramPanels}
      </div>


      <div className="flex justify-center items-center mt-4">暗号コード</div>
      <div className="flex justify-center items-center mt-2">
        {cryptCodePanels}
      </div>


      <div className="flex justify-center items-center border-gray-700 mt-4 py-4">
        {wordPanels}
      </div>

      <div className="mt-3">
        <button className="bg-blue-700 text-white rounded px-5 py-2" onClick={handleSave}>保存</button>
      </div>
    </div>
  );
}

export default App;
